import { combineReducers } from 'redux';
import notifications from './notifications';
import correlations from './correlations';
import authentication, * as authenticationSelector from './authentication';
import configuration, * as configurationSelector from './configuration';
import passwordResets from './passwordResets';
import twoFAResets from './twoFAResets';
import modalDialogs from './modalDialogs';
import fileUploads from './fileUploads';
import copyOfManualCashLimit from './copyOfManualCashLimit';
import envConfiguration from './envConfiguration';
import extraUploadConfirmationNeeded from './extraUploadConfirmationNeeded';
import userConfiguration, * as userConfigurationSelector from './userConfiguration';

export default combineReducers({
    notifications,
    correlations,
    authentication,
    configuration,
    passwordResets,
    twoFAResets,
    modalDialogs,
    extraUploadConfirmationNeeded,
    fileUploads,
    copyOfManualCashLimit,
    envConfiguration,
    userConfiguration,
});

export const getNotifications = (state) => state.notifications;
export const getCorrelations = (state) => state.correlations;
export const getPreAuthenticationToken = (state) => authenticationSelector.getPreAuthenticationToken(state.authentication);
export const getAccessToken = (state) => authenticationSelector.getAccessToken(state.authentication);
export const getDaysToPasswordExpiration = (state) => authenticationSelector.getDaysToPasswordExpiration(state.authentication);
export const getPublicConfig = (state) => configurationSelector.getPublicConfig(state.configuration);
export const getPrivateConfig = (state) => configurationSelector.getPrivateConfig(state.configuration);
export const getServerTimeOffset = (state) => configurationSelector.getServerTimeOffset(state.configuration);
export const getWebSocketErrorSentTime = (state) => configurationSelector.getWebSocketErrorSentTime(state.configuration);
export const getPasswordResetToken = (state) => state.passwordResets;
export const get2FAResets = (state) => state.twoFAResets;
export const getModalDialogs = (state) => state.modalDialogs;
export const getFileUploads = (state) => state.fileUploads;
export const getCopyOfManualCashLimit = (state) => state.copyOfManualCashLimit;
export const getEnvConfiguration = (state) => state.envConfiguration;
export const isExtraUploadConfirmationNeeded = (state) => state.extraUploadConfirmationNeeded;
export const getBiddingUserConfiguration = (state) => userConfigurationSelector.getBiddingUserConfiguration(state.userConfiguration);
export const getTrustedDeviceUserConfiguration = (state) => userConfigurationSelector.getTrustedDeviceUserConfiguration(state.userConfiguration);
